export default __webpack_public_path__ + "static/media/artem_tkachuk.1c1aab7e.jpeg";